export default "__VITE_ASSET__BW_lbQz5__"